/* eslint-disable no-unused-vars */
import { observer } from "mobx-react-lite";
import * as React from "react";
import { useStore } from "../../root-store-context";
import { App, Button, Space, Spin, Typography } from "antd";
import { useEffect, useState } from "react";
import { PropertyJobDetail } from "../../api/Api_v2";
import { RcFile } from "antd/es/upload";

const { Text, Link } = Typography;

export const Send = observer(() => {
  const { applicationStore, modalViewerStore, stepByStepTabStore } = useStore();
  const [data, setData] = useState<PropertyJobDetail[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { modal, notification } = App.useApp();

  useEffect(() => {
    if (stepByStepTabStore.currentStep === 5) {
      setIsLoading(true);
      applicationStore.GetJobDescription().then((res) => {
        setData(res || []);
        setIsLoading(false);
      });
    } else {
      setData([]);
    }
  }, [stepByStepTabStore.currentStep]);

  const onReviewRecipientInfo = async () => {
    const res = await applicationStore.getExelFile();
    const url = window.URL.createObjectURL(new Blob([res]));
    modalViewerStore.openFileByUrl(url, "Recipient Info.xlsx");
  };

  const openViewFile = (file: RcFile) => {
    const blob = new Blob([file], { type: "application/pdf" });
    const fileURL = URL.createObjectURL(blob);
    modalViewerStore.openFileByUrl(fileURL, "Recipient Info.pdf");
  };

  const onSendMailJob = () => {
    return new Promise<void>((resolve, reject) => {
      const needApprove = data.some(
        (i) => i.numberOfRecipients > i.recipientsCount * 0.25
      );
      modal.confirm({
        className: "cam__confirm-modal",
        title: "Confirmation",
        content: (
          <Space direction="vertical">
            <Text>Are you sure you want to generate the mailing?</Text>
            {needApprove && (
              <Text>Due to the volume of recipients, this mailing requires approval before it is sent.</Text>
            )}
          </Space>
        ),
        okText: "Yes",
        cancelText: "No",
        okButtonProps: { className: "cam__button-primary" },
        cancelButtonProps: { className: "cam__button-secondary" },
        onOk: async () => {
          const result = await applicationStore.Create();
          if (result) {
            notification.success({ message: `Mailing submitted successfully. Reference ID: ${result}.`, duration: 10 });
            stepByStepTabStore.setTab(1);
            applicationStore.cleanMailJob();
            resolve();
          } else {
            notification.error({ message: "An error occurred while creating the mailing job. Please refresh the page and try again.", duration: 10 });
            reject();
          }
        },
        onCancel: () => reject(),
      });
    });
  };

  const onCancel = () => {
    return new Promise<void>((resolve, reject) => {
      modal.confirm({
        className: "cam__confirm-modal",
        title: "Confirmation",
        content: (
          <>
            <Text>Are you sure you want to cancel?</Text>{" "}
            <Text type="danger">Data will be lost if the mailing job is canceled.</Text>
          </>
        ),
        okText: "Yes",
        cancelText: "No",
        okButtonProps: { className: "cam__button-primary" },
        cancelButtonProps: { className: "cam__button-secondary" },
        onOk: async () => {
          const result = await applicationStore.Cancel();
          if (result != null) {
            stepByStepTabStore.setTab(1);
            applicationStore.cleanMailJob();
            resolve();
          } else {
            notification.error({ message: "An error occurred while canceling. Please refresh the page and try again.", duration: 10 });
            reject();
          }
        },
        onCancel: () => reject(),
      });
    });
  };

  return (
    <Spin spinning={isLoading}>
      <Space direction="vertical" style={{ width: "100%" }}>
        <Text>
          <Text strong>COMMUNICATION TYPE:</Text>{" "}
          {applicationStore.communicationType.comTypeName}
        </Text>
        <Text strong>MAILING JOB DETAILS:</Text>

        {data.map((detail) => (
          <Space key={detail.propertyName} direction="vertical" style={{ marginTop: "15px" }}>
            <Text><Text strong>PROPERTY:</Text> {detail.propertyName}</Text>
            {detail.files?.map((v, i) => (
              <Link key={`${detail.propertyName}-file-${i}`} onClick={() => openViewFile(v.file)}>
                {v.name}
              </Link>
            ))}
            <Text><Text strong>NUMBER OF RECIPIENTS:</Text> {detail.numberOfRecipients}</Text>
            <Text><Text strong>NUMBER OF DOCUMENTS PRINTED:</Text> {detail.numberOfDocumentsPrinted}</Text>
            <Text><Text strong>NUMBER OF PAGES PRINTED:</Text> {detail.numberOfDocumentsPagesPrinted}</Text>
            {applicationStore.mailJob.deliveryMethodId === 1 && (
              <Text><Text strong>NUMBER OF PAGES EMAILED:</Text> {detail.numberOfDocumentsPagesEmailed}</Text>
            )}
          </Space>
        ))}

        <Text style={{ marginTop: "15px" }}>
          <Text strong>MAILING OPTIONS SELECTED:</Text>
          <br />
          {applicationStore.selectedDeliveryMethod.find((i) => i.id === applicationStore.mailJob.deliveryMethodId)?.methodName}
          <br />
          {applicationStore.selectedPrintPreferenceMethod.find((i) => i.id === applicationStore.mailJob.printPreferenceMethodId)?.optionName}
          <br />
          {applicationStore.selectedPrintColorMethod.find((i) => i.id === applicationStore.mailJob.printColorId)?.optionName}
        </Text>
      </Space>

      <div className="cam__send-actions">
        <div className="cam__send-actions-left">
          <Button
            data-testid="cam-review-recipient-info-btn"
            className="cam__button-primary"
            type="primary"
            size="large"
            onClick={onReviewRecipientInfo}
          >
            Review Recipient Info
          </Button>
        </div>
        <div className="cam__send-actions-right">
          <Button
            data-testid="cam-confirm-send-btn"
            className="cam__button-primary"
            type="primary"
            size="large"
            onClick={onSendMailJob}
          >
            Confirm and send
          </Button>
          <Button
            data-testid="cam-send-cancel-btn"
            className="cam__button-secondary"
            size="large"
            onClick={onCancel}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Spin>
  );
});